export default "__VITE_ASSET__DsK_e9tg__"